module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-all",
    on: {
      "mouseenter": _vm.showActions,
      "mouseleave": _vm.hideActions
    }
  }, [_c('i', {
    staticClass: "ico-alert color-6 huge"
  }), _vm._v(" "), (_vm.inputType) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.notes[_vm.index].note),
      expression: "reservation.notes[index].note"
    }],
    staticClass: "col-sm-10",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.notes[_vm.index].note)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.editedNote.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.notes[_vm.index], "note", $event.target.value)
      }
    }
  }) : _c('span', [_vm._v("\n        " + _vm._s(_vm.reservation.notes[_vm.index].note) + "\n    ")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.actions) ? _c('div', {
    staticClass: "notes-actions"
  }, [_c('i', {
    staticClass: "ico-edit pointer largest medium",
    on: {
      "click": _vm.editNote
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "ico-delete pointer largest medium",
    on: {
      "click": _vm.deleteNote
    }
  })]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-536f07d4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/Note.vue
// module id = 1845
// module chunks = 0